import type {ReactNode} from "react";

import {createContext, useContext} from "react";

type OverlayPortalContextValue = (() => HTMLElement | null) | null;

const OverlayPortalContext = createContext<OverlayPortalContextValue>(null);

interface OverlayPortalProviderProps {
  children: ReactNode;
  getContainer: () => HTMLElement | null;
}

export function OverlayPortalProvider({children, getContainer}: OverlayPortalProviderProps) {
  return <OverlayPortalContext value={getContainer}>{children}</OverlayPortalContext>;
}

export function useOverlayPortalContainer() {
  const getContainer = useContext(OverlayPortalContext);

  return getContainer?.() ?? null;
}
